import { useQuery } from '@tanstack/react-query';
import currencyService from 'v2/services/currency';

export function useCurrencies() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['currencies'],
    queryFn: () => currencyService.list()
  });

  return { data: data ?? [], isLoading, error };
}
